import { render, staticRenderFns } from "./VatSettings.vue?vue&type=template&id=59c810b7"
import script from "./VatSettings.vue?vue&type=script&lang=ts"
export * from "./VatSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c810b7')) {
      api.createRecord('59c810b7', component.options)
    } else {
      api.reload('59c810b7', component.options)
    }
    module.hot.accept("./VatSettings.vue?vue&type=template&id=59c810b7", function () {
      api.rerender('59c810b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/VatSettings.vue"
export default component.exports